import { FullPageLoader } from 'components/Loader/Loader';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { RootState } from 'store';
import createUserApi from 'api/user';
import qs from 'qs';
import { getTypes, hasType } from 'utils/account-type';
import { contextToAccountType } from 'modules/user/userSlice';

const LoginSetup: FC = () => {
  const { isAuthenticated, ready } = useSelector((state: RootState) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const search = qs.parse(location.search, { ignoreQueryPrefix: true });

  useEffect(() => {
    async function checkCustomer() {
      if (!ready) {
        return;
      }

      if (!isAuthenticated) {
        history.replace('/');
        return;
      }
      const currentContext = (search.context ?? 'mychooose') as PortalContext;
      const user = await createUserApi(currentContext).getInfo();
      const accountType = contextToAccountType[search.context as string];
      const { inviteId, claimCode, context } = search;

      if (hasType(getTypes(user.accounts), [accountType])) {
        const account = user.accounts.find(u => u.type === accountType) as Account;
        const newSearch = qs.stringify({ invite: inviteId, code: claimCode, customerId: account.customerId, context });
        history.replace({ pathname: '/invite', search: newSearch });
        return;
      }

      const newSearch = qs.stringify({ inviteId, claimCode });
      if (search.context === 'wechooose') {
        history.replace({ pathname: '/signup/wechooose', search: newSearch });
        return;
      } else if (search.context === 'mychooose') {
        history.replace({ pathname: '/signup/mychooose', search: newSearch });
        return;
      }

      history.replace('/');
    }

    checkCustomer();
  }, [ready, isAuthenticated, history, search]);

  return <FullPageLoader />;
};

export default LoginSetup;
